import React, {useState, useEffect} from 'react';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap';

class Comments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        commentsList: [],
        newCommentText:"",
        commentDate:""
    }
   this.sendComment = this.sendComment.bind(this);
   this.callComments = this.callComments.bind(this);
  }

  //Just put the correct time on the snoozer
  componentDidMount(){
    let currentTimeDate = Time.getComputerTimeDate();
    this.setState({commentDate:currentTimeDate});
    this.callComments();

  }

  callComments = async () => {

    let user = this.props.user;
    let id = this.props.id;
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/notifications/comments.php?notificationId="+this.props.id);
    const result = await fetchRequest.json();
    console.log(result);
    this.setState({commentsList:result});

  }

  handleFormChange = (e) =>{
      this.setState({[e.target.id]: e.target.value});
  }
  
  sendComment = (e) =>{

    e.preventDefault();

    console.log("Comment from: "+this.props.user);
    console.log("NotificationId: "+this.props.id);

    const formdata = new FormData();
    formdata.append("notificationId", this.props.id);
    formdata.append("username", this.props.user);
    formdata.append("commentText",this.state.newCommentText);
    formdata.append("commentDate",this.state.commentDate)

    const requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/notifications/addcomment.php", requestOptions)
    .then(response => response.text())
    .then(result => this.props.close())
    .catch(error => console.log('error', error));

  }

  render() {

    let commentsListHTML;
    if(this.state.commentsList.length > 0){
      commentsListHTML = this.state.commentsList.map((comment, index) =>

      <tr key={index.toString()} i={index}>
        <td>{comment.userName}</td>
        <td>{comment.commentDate}</td>
        <td>{comment.commentText}</td>
      </tr>
      
      )
    }else{
      
    }

    return(
      <div>
        <div className='pop-up comments-popup' onClick={this.props.close}></div>
        <div className="container pop-up-window comments-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>Comments</h3>
                  <div className='comment-section'>
                    <table class="table">
                      <thead>
                          <tr>
                              <th scope="col-1">User</th>
                              <th scope="col-1">Date</th>
                              <th scope="col-10">Comment</th>
                          </tr>
                      </thead>
                      <tbody>
                        {commentsListHTML}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-12 container p-4">
                  <form onSubmit={this.sendComment}>
                    <div class="mb-3">
                        <label class="form-label">Comment</label>
                        <textarea onChange={this.handleFormChange} class="form-control" id="newCommentText" rows="3"></textarea>
                    </div>
                    <button type="submit" className="btn btn-primary">Comment</button>
                  </form>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

export default Comments;